import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import playerModal from './playerModal.vue';
import { videoList, getCustomer } from './request.js';
import mixin from './mixin.js';
import moment from 'moment';
export default {
  mixins: [mixin],
  components: {
    playerModal
  },
  data() {
    return {
      form: {
        customerId: '',
        userId: '',
        startRecordTime: []
      },
      current: 1,
      beginTime: [],
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'seq',
        key: '1',
        align: 'center',
        scopedSlots: {
          customRender: 'seq'
        }
      }, {
        slots: {
          title: '账号ID'
        },
        dataIndex: 'userId',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '视频大小'
        },
        dataIndex: 'size',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '视频ID'
        },
        dataIndex: 'loginId',
        key: '4',
        align: 'center'
      }, {
        slots: {
          title: '录屏开始时间'
        },
        dataIndex: 'startAt',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '创建时间'
        },
        dataIndex: 'createAt',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 150,
        key: '9'
      }]
    };
  },
  created() {
    getCustomer({}).then(res => {
      this.customerList = res;
      this.form.customerId = this.customerList[0].id;
    });
    this.searchFun();
  },
  methods: {
    customerChange(value) {
      this.form.customerId = value;
      sessionStorage.setItem('selectCustomIdSystem', value);
      this.searchFun();
    },
    tabFun(value) {
      this.current = value;
      if (value === 2) {
        let selectCustomIdSystem = sessionStorage.getItem('selectCustomIdSystem');
        this.form.customerId = selectCustomIdSystem ? Number(selectCustomIdSystem) : this.customerList[0].id;
      }
      this.sourceChange();
    },
    sourceChange() {
      this.data = [];
      this.form.userId = '';
      this.form.startRecordTime = [];
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.pagination.total = 0;
      this.beginTime = [];
      this.searchFun();
    },
    searchFun() {
      let {
        current,
        pageSize
      } = this.pagination;
      let {
        customerId,
        startRecordTime,
        userId
      } = this.form;
      userId = userId ? userId.replace(/\s*/g, '') : '';
      let startAt = startRecordTime[0] ? moment(startRecordTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
      let endAt = startRecordTime[1] ? moment(startRecordTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
      let params = {
        page: current,
        pageSize: pageSize,
        source_channel: this.current,
        userId: userId,
        startAt: startAt,
        endAt: endAt
      };
      if (this.current === 2) {
        params.customerId = customerId;
      }
      videoList(params).then(res => {
        let currentIndex = (current - 1) * pageSize;
        if (res && res.items) {
          res.items.forEach(item => {
            currentIndex++;
            item.seq = currentIndex;
          }) || [];
          this.data = res.items;
          this.pagination.total = res.totalNum || 0;
        }
      });
    }
  }
};